<bl-page-card-container
  data-smartpresentation="container-pagina"
  backNavigation=".."
  [showTooltip]="true"
  [tooltipKey]="pageTooltip"
  (onCopyUrlFilters)="onCopyUrlFilters()"
  >
  <ng-container header>
    <div class="flex align-items-center">
      <ag-views-toolbar [grid]="agGrid" [gridKey]="GRID_KEY"></ag-views-toolbar>
      <bl-competencia
        class="ml-4"
        [competencia]="competenciaRange[0]"
        [competenciaFinal]="competenciaRange[1]"
        (apply)="competenciaChanged($event)"
      ></bl-competencia>
      <p-floatlabel variant="on" class="ml-2">
        <p-select
          size="small"
          [options]="anosBasesOptions"
          [(ngModel)]="anoBase"
          (onChange)="filterChanged = true"
        ></p-select>
        <label>Realização</label>
      </p-floatlabel>
      <p-floatlabel variant="on" class="ml-2">
        <p-select
          size="small"
          [options]="faixasEtariasOptions"
          [(ngModel)]="faixaEtaria"
          (onChange)="filterChanged = true"
        ></p-select>
        <label>Faixa etária</label>
      </p-floatlabel>
      <div class="field-checkbox ml-4 mb-0">
        <p-checkbox
          [(ngModel)]="criticaPendente"
          [binary]="true"
          (onChange)="filterChanged = true"
          inputId="critica"
        ></p-checkbox>
        <label for="critica">Crítica pendente</label>
      </div>
      <button
        data-smartpresentation="botao-pesquisar"
        pButton
        type="button"
        icon="pi pi-search"
        iconPos="left"
        label="Pesquisar"
        class="ml-4 mr-4 p-button p-button-md"
        [ngClass]="{ 'p-disabled': !filterChanged }"
        (click)="reloadData()"
      ></button>

      @if (pseudonimizarActionVisible) {
        <button
          class="p-button p-button-outlined p-button-icon-only"
          (click)="togglePseudonimizar()"
          [title]="(pseudonimizarAction ? 'Desativar' : 'Ativar') + ' Pseudonimização'"
          >
          <i class="pi" [ngClass]="pseudonimizarAction ? 'pi-eye-slash' : 'pi-eye'"></i>
        </button>
      }
      <button
        class="p-button p-button-outlined p-button-icon-only ml-2"
        (click)="exportExcel()"
        pTooltip="Exportar Listagem como XLSX"
        tooltipPosition="bottom"
        [disabled]="!rowData?.length"
        >
        <i class="pi pi-file-excel"></i>
      </button>
      <button
        data-smartpresentation="botao-tela-cheia"
        class="p-button p-button-outlined p-button-icon-only ml-2"
        (click)="toggleFullscreen()"
        pTooltip="Tela Cheia"
        tooltipPosition="bottom"
        >
        <i
          class="pi"
          [ngClass]="{ 'pi-window-maximize': !(fullscreen$ | async), 'pi-window-minimize': (fullscreen$ | async) }"
          >
        </i>
      </button>
    </div>
  </ng-container>

  <div class="flex flex-1">
    <ag-grid-angular
      #agGrid
      data-smartpresentation="ag-grid"
      class="ag-theme-balham w-full"
      [style.height]="gridHeight$ | async"
      [rowData]="rowData"
      [gridOptions]="gridOptions"
      [overlayLoadingTemplate]="firstLoad ? 'Clique em Pesquisar para exibir os registros' : null"
      >
    </ag-grid-angular>
  </div>
</bl-page-card-container>

<p-dialog
  [(visible)]="detalheGuiaDisplay"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [maximizable]="true"
  [style]="{ width: '90vw', height: '90vh' }"
  header="Detalhes da guia/lançamento"
  >
  <bl-detalhes-guia
    [operadora]="operadora"
    [cdGuiaMonitor]="detalheGuiaCodigo"
    (onChange)="showDetalheGuiaFor($event)"
  ></bl-detalhes-guia>
</p-dialog>
